import { useState } from "react";
const SearchBar = ({ onSearch }) => {
  const [city, setCity] = useState("London");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (city.trim()) onSearch(city);
  };

  return (
    <form onSubmit={handleSubmit} className="search-bar">
      <input
        value={city}
        onChange={(e) => setCity(e.target.value)}
        className="search-input"
      />
      <button className="search-button">Search</button>
    </form>
  );
};
export default SearchBar;
